<template>
  <v-container>
    <chart/>
  </v-container>
</template>

<script>
import Chart from "@/components/Chart";

export default {
  name: "Statistics",
  components: {Chart},
  data() {
    return {
    }
  },
  mounted() {
  }
}
</script>

<style>
</style>